<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-29 16:04:17
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-09-08 16:55:53
--> 
<template>
  <!-- 下拉列表组件 -->
  <div>
    <span class="ml-2">{{label?label:$t('label_Business_functions')}}</span>
    <v-menu offset-y
            :disabled='disabled'
            :close-on-content-click='false'>
      <!--  v-bind="attrs"
                v-on="on" -->
      <template v-slot:activator="{ on, attrs }">
        <span class="d-flex justify-space-between pl-2"
              style="width:100%;border-bottom:1px solid black"
              :style="{'background-color':uuid?'#ffffff':'#e2e2e2'}"
              v-bind="attrs"
              v-on="on">
          <span class="d-flex justify-center align-center">
            <span style="display:block;line-height: 50px;"
                  v-if="!multiple">
              {{uuid?uuidName:(placeholder?placeholder:$t('label_The_name_of_the_function')+'/'+$t('label_Short_code'))}}
            </span>
            <slot name='activator'
                  style="display:block;line-height: 50px;"
                  :item='uuidName'
                  v-else>
            </slot>
          </span>
          <span style="display:block;line-height: 50px;"
                class="mr-2">
            <v-icon class="material-icons"
                    v-if="iconShow">expand_more</v-icon>
          </span>
        </span>
      </template>
      <v-list style="max-height:500px">
        <v-list-item v-for="(item, index) in selectlist"
                     :key="index"
                     @click="selectItem(item)"
                     class="pl-0"
                     style="background-color:#ffffff">
          <v-list-item-title>
            <slot name='listItem'
                  v-bind:item="item"></slot>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script> 
/**
 * iconShow   是否显示下拉图标
 * disabled   禁止点击
 * selectlist 下拉列表
 * uuid v-model绑定值 多选传对象
 * keyCompare   select比较值  两个数组的比较值  
 * placeholder   默认显示值
 * keyView      显示值
 * <template #listItem='{item}'>  插槽列表每一项
        <p>{{item.name}}---{{item.uuid}}</p>
      </template>
 * <template #activator='{item}'>  多选插槽
              <span v-for="item1 in item"
                    :key="item1.uuid">
                {{item1.uuid}}
              </span>
            </template>
 */
export default {
  components: {},
  props: {
    placeholder: {
      type: String
    },
    label: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    iconShow: {
      type: Boolean,
      default: true
    },
    selectlist: {
      type: Array,
      default: () => []
    },
    uuid: {
      type: [String, Array],
      default: ''
    },
    keyCompare: {
      type: String,
      default: 'uuid'
    },
    keyView: {
      type: String,
      default: 'name'
    },
    multiple: {
      type: Boolean,
      default: false
    },
  },
  model: {
    prop: 'uuid',
    event: 'change'
  },
  data () {
    return {
    };
  },
  computed: {
    uuidName () {
      if (!this.uuid) return ''
      if (this.multiple) { //多选
        const uuid = this.selectlist.filter(item => {
          let isNo = true
          this.uuid.forEach(item1 => {
            if (item[this.keyCompare] == item1[this.keyCompare]) {
              isNo = false
            }
          })
          if (!isNo) {
            return item
          }
        })
        return uuid
      }
      else {
        const uuid = this.selectlist.filter(item => {
          return item[this.keyCompare] == this.uuid
        })
        return uuid[0][this.keyView]
      }
    }
  },
  created () { },
  watch: {
    uuid (v) {

    }
  },
  mounted () { },

  methods: {
    selectItem (item) {
      this.$emit('selectItem', item)
    }
  },
};
</script>

<style scoped>
</style>
